module.exports = "https://www.gc-pro.gnp.com.mx/ec983df90fc08b7dbb1d2b7de6b9ac9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_poliza.png
// module id = 247
// module chunks = 0